import { Component, Input } from '@angular/core';

import {
  IContractByNumberFormData,
  IControlsFromResolver
} from './../../../../models/contract';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { DetailLotEnum, IContractLot, ILot } from 'src/app/models/generic';
import { StatusBadgeTone } from 'src/app/shared/components/status-badge/status-badge.component';
import { contractStatusTone } from 'src/app/shared/utils/status-badge.util';

@Component({
  selector: 'app-cards-contratos-lotes',
  templateUrl: './cards-contratos-lotes.component.html',
  styleUrls: ['./cards-contratos-lotes.component.scss']
})
export class CardsContratosLotesComponent {
  @Input() contract!: IContractLot;
  @Input() showBeneficiaryName: boolean = false;
  @Input() lot?: ILot;
  @Input() typeDetail: DetailLotEnum = DetailLotEnum.Invoicing;
  @Input() isModal: boolean = false;
  @Input() isManual: boolean = false;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';

  DetailLotEnum = DetailLotEnum;

  inputControlsFromResolver!: IControlsFromResolver;

  currentTab = 1;

  currentVersion = false;

  modeUrl = 'visualizar';
  isDelete: boolean = false;

  constructor(private _dialogService: ApiDialogService) {}

  get statusTone(): StatusBadgeTone {
    return contractStatusTone(this.contract.StatusOverride || this.contract.Status, {
      toReverse: this.contract.ToReverse === true
    });
  }

  openModalDetails(number: string) {
    const data: IContractByNumberFormData = {
      Number: number,
      Contract: this.contract
    };

    this._dialogService.openContractDetailsDialog(data).then((response) => {});
  }
}
